import { getDefaultPath } from 'src/library/helpers/url_sync'
import { isServer } from 'src/library/helpers/isServer'
import actions, { getView } from './actions'
const preKeys = getDefaultPath()
const initState = {
  collapsed: !(!isServer && window.innerWidth > 1220),
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  lastURLKey: '',
  viewMode: 'worker'
}

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLAPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed,
      }
    case actions.COLLAPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      }
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height,
        }
      }
      break
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys,
      }
    case actions.CHANGE_CURRENT:
      return {
        ...state,
        current: action.current,
      }
    case actions.CHANGE_LAST_URL_KEY:
      return {
        ...state,
        lastURLKey: action.lastURLKey,
      }
    case actions.CHANGE_VIEW_MODE:
      localStorage.setItem('viewMode', action.mode);
      return {
        ...state,
        viewMode: action.mode,
      }
    case actions.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: [],
      }
    default:
      return state
  }
  return state
}
